/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  ListItemIcon,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import moment from "moment";
import { UrlApi } from "../../../../../services/apirest";
import { calcularVencimientoPorPeriodo } from "../../../utils/calcvencimiento";
import { v4 as uuidv4 } from "uuid";
import { postData, putData } from "../../../../../services/library";
import Notify from "../../../../Notify";
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Assignment as AssignmentIcon,
  AccessTime as AccessTimeIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  CalendarToday as CalendarTodayIcon,
  Build as BuildIcon,
  History as HistoryIcon,
  Edit,
} from "@mui/icons-material";
import ToggleOnRoundedIcon from "@mui/icons-material/ToggleOnRounded";
import ToggleOffRoundedIcon from "@mui/icons-material/ToggleOffRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { useTareas } from "../../../hooks/useTareas"; // Hook personalizado para manejar la lógica de tareas
import { TareasForm } from "./TareasForm";
import { TarjetasTareas } from "./CardsTareas";
import { TablaTareas } from "./TablaTareas";
export default function Tareas({
  selectedEquipo,
  tasksDialogOpen,
  handleCloseTasksDialog,
}) {
  const [Notificacion, setNotificacion] = useState({
    open: null,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [tabValue, setTabValue] = useState(0);
  const [viewMode, setViewMode] = useState("table");

  const {
    DatosForm,
    frecuencias,
    isSubmitting,
    editMode,
    tareasFiltradas,
    mostrarInactivas,
    setMostrarInactivas,
    handleChange,
    handleEdit,
    onGuardar,
    putActiva,
    onEliminar,
    resolverAlerta,
    Toast,
  } = useTareas(selectedEquipo);

  const handleViewModeChange = (event, newValue) => {
    setTabValue(newValue);
    setViewMode(newValue === 0 ? "table" : "cards");
  };

  // Renderizado de chips de estado para tareas
  const renderTaskStatusChip = (vencimiento) => {
    const today = moment().startOf("day");
    const due = moment(vencimiento).startOf("day");
    const daysLeft = due.diff(today, "days");
    if (due.isBefore(today)) {
      return (
        <Chip
          icon={<WarningIcon />}
          label="Vencido"
          color="error"
          size="small"
          sx={{
            bgcolor: "rgba(209, 69, 59, 0.3)",
            color: "#b71c1c",
            fontWeight: "bold",
          }}
        />
      );
    }
    return (
      <Chip
        icon={<CheckCircleIcon />}
        label={`En tiempo (${daysLeft} días)`}
        color="success"
        size="small"
        sx={{
          bgcolor: "rgba(76, 175, 80, 0.3)",
          color: "#1b5e20",
          fontWeight: "bold",
        }}
      />
    );
  };

  const obtenerEstadoTarea = (tarea) => {
    if (!tarea.activa) return "inactiva";

    const today = moment().startOf("day");
    const due = moment(tarea.vencimiento).startOf("day");
    const daysLeft = due.diff(today, "days");

    if (due.isBefore(today)) {
      return "vencida";
    } else if (daysLeft <= 7) {
      return "por_vencer";
    } else if (daysLeft >= 0) {
      return "al_dia";
    }
  };

  return (
    <div>
      <Dialog
        open={tasksDialogOpen}
        onClose={handleCloseTasksDialog}
        maxWidth="md"
        fullWidth
      >
        <form method="post" onSubmit={onGuardar}>
          <DialogTitle>
            Tareas de Mantenimiento - {selectedEquipo?.equipo}
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              Gestione las tareas de mantenimiento para este equipo
            </DialogContentText>
            {selectedEquipo && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                  }}
                >
                  <Box>
                    <Typography variant="h6">
                      {selectedEquipo.id} - {selectedEquipo.equipo}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Sección: {selectedEquipo.sector}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Tabs value={tabValue} onChange={handleViewModeChange}>
                      <Tab label="Tabla" />
                      <Tab label="Tarjetas" />
                    </Tabs>

                    <Typography>
                      Mostrar tareas{" "}
                      {mostrarInactivas ? "Activas" : "Inactivas"}
                      <IconButton
                        onClick={() => setMostrarInactivas((prev) => !prev)}
                        color={mostrarInactivas ? "success" : "error"}
                      >
                        {mostrarInactivas ? (
                          <ToggleOnRoundedIcon />
                        ) : (
                          <ToggleOffRoundedIcon />
                        )}
                      </IconButton>
                    </Typography>
                  </Box>
                </Box>
                {viewMode === "table" && (
                  <TablaTareas
                    obtenerEstadoTarea={obtenerEstadoTarea}
                    onMarcarInactiva={putActiva}
                    onEditar={handleEdit}
                    tareas={tareasFiltradas}
                    onEliminar={onEliminar}
                    onResolverAlerta={resolverAlerta}
                  />
                )}
                {viewMode === "cards" && (
                  <TarjetasTareas
                    tareas={tareasFiltradas}
                    onEditar={handleEdit}
                    obtenerEstadoTarea={obtenerEstadoTarea}
                    onMarcarInactiva={putActiva}
                    onEliminar={onEliminar}
                    onResolverAlerta={resolverAlerta}
                  />
                )}
                {/* Formulario para agregar/editar tarea */}
                <TareasForm
                  DatosForm={DatosForm}
                  frecuencias={frecuencias}
                  handleChange={handleChange}
                  editMode={editMode}
                />
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTasksDialog}>Cerrar</Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={editMode ? <Edit /> : <AddIcon />}
              disabled={isSubmitting}
            >
              {editMode ? "Editar" : "Agregar"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {Toast}
    </div>
  );
}
